import { cloneDeep, flatten } from 'lodash'

import { DashboardsViews, DashboardWidgetName, Sort } from '@types'

export default async (dashboardViews: DashboardsViews[]) => {
  return dashboardViews.map(dashboardView => {
    let isUpdated = false
    const widgets = dashboardView.widgets?.map(widget => {
      if ([
        DashboardWidgetName.ValuePivot,
        DashboardWidgetName.IncomePivot,
        DashboardWidgetName.PerformancePivot,
      ].includes(widget.name)) {
        widget.attrs.configs = (widget.attrs.configs ?? []).map((config: any) => {
          let mappedConfig = cloneDeep(config)
          if (Array.isArray(mappedConfig.sortRows) && mappedConfig.sortRows.length) {
            mappedConfig.sortRows = mappedConfig.sortRows.reduce((acc: Sort[], item: Sort) => {
              try {
                // check if item is old value
                const field = JSON.parse(item.field)
                if (Array.isArray(field)) {
                  isUpdated = true
                  const list = [...new Set(flatten(field))]
                  acc.push(...list.map((field: string, index: number) => ({
                    ...item,
                    key: `${item.key ?? 'sort'}${index}`,
                    field: field,
                  })))
                } else {
                  throw new Error()
                }
              } catch {
                acc.push(item)
              }
              return acc
            }, [])
          }
          return mappedConfig
        })
        return widget
      }
      return widget
    })
    return isUpdated ? { ...dashboardView, widgets } : dashboardView
  })
}
